import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-374b06b5")

_pushScopeId("data-v-374b06b5")
const _hoisted_1 = { class: "uk-width-5-6" }
const _hoisted_2 = {
  key: 0,
  class: "upload__caption__title"
}
const _hoisted_3 = {
  key: 0,
  class: "upload__caption__subtext"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "continue_prompt" }, "CLICK ANYWHERE TO CONTINUE", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    appear: ""
  }, {
    default: _withId(() => [
      (_ctx.checkEnd())
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "upload__modal modal",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stepLoader && _ctx.stepLoader(...args)))
          }, [
            _createVNode("div", _hoisted_1, [
              (_ctx.title)
                ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subtexts, (subtext, index) => {
                return (_openBlock(), _createBlock("div", { key: subtext }, [
                  _createVNode(_Transition, {
                    name: "shift-fade",
                    appear: ""
                  }, {
                    default: _withId(() => [
                      (_ctx.showSubtext(index))
                        ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(subtext), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128))
            ]),
            _hoisted_4
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})